export default __webpack_public_path__ + "static/media/waitOutline.d1935894.svg";